<div class="container" style="margin-top: 2em;">
    <!--
    <h1 class="mt-5">Jon Ray Building</h1>
    <p class="lead">Providing a high quality building service to clients in East Sussex, Kent and surrounding areas.</p>
    -->

    <h2>How it all started</h2>
    <p>
        Jon Ray Building commenced trading in 1994 (became a limited company in 2002) serving all building needs for their clients, many of whom have been loyal customers 
        over many years up to the present day.                                                                                                                                                              
        Jon Ray was born in East Sussex &amp; grew up in a family where building was never far from the agenda, with his father Chris (a busy chartered quantity surveyor) &amp; 
        grandfather Denis who had spent a lifetime in the management of established local building companies. From a young age Jon soon found he was developing a strong interest in building &amp; 
        liked to listen in to the conversations between his dad &amp; grandfather &amp; when possible go out on site with them especially if they were delivering materials in a works van 
        or truck.                                                                                                 
    </p>


    <div class="card align-content-center text-center mx-auto d-block image">
        <img src="/assets/images/Portfolio/017e.jpg" class="card-img-top img-fluid center" alt="Jon Ray Building - high quality property renovation in Sussex and Kent">
    </div>

    <p>
        Jon left school aged 16 &amp; immediately started work with a local building firm labouring through the summer months. 
        Using the many building contacts his family had, he interviewed &amp; enrolled on an apprenticeship scheme with a well established large local building company
        to start later that September. Jon subsequently completed his 3-year college / work placement apprenticeship gaining an Advanced City &amp; Guilds qualification in carpentry &amp; joinery. 
        Jon continued working on all sorts of different building jobs &amp; projects gaining ever more knowledge &amp; on the job experience by working alongside many experienced tradesmen, 
        before leaving in 1994 to set himself up to be self-employed &amp; start Jon Ray Building.                   
    </p>


    <p>
        Carpentry &amp; joinery work mainly on domestic properties &amp; some shops kept Jon very busy with attention to detail being at the heart of all work he carried out. 
        On the back of this, his client list grew &amp; so did the work demand’s, which soon included decorating, roofing, plastering, bricklaying 
        as more clients asked for all aspects of work covered under the organisation &amp; supervision of Jon. 
        To accommodate this growing client request &amp; continue carrying out ever more larger building projects Jon started working more closely with his father Chris 
        whose experience, conscientious &amp; methodical approach became the mainstay in carrying out all tasks. 
        Employing &amp; working with other skilled trades which were already known by the family dating back from his grandfather through to the many skilled tradesmen Jon himself had worked with, 
        were then able to assemble a good, conscientious team &amp; complete the ever growing list of job contracts.
    </p>

    <div class="card align-content-center text-center mx-auto d-block image">
        <img src="/assets/images/Portfolio/022a.jpg" class="card-img-top img-fluid center" alt="Jon Ray Building - high quality property renovation in Sussex and Kent">
    </div>

    <p>
        With work as busy as ever, in 2002 Jon restructured &amp; became a limited company. Jon &amp; Chris worked hard in trying to meet the needs of all their clients &amp; 
        establish a regular client base &amp; have, along with their good team of regular experienced &amp; now, some younger trades too, found a blend of sympathetic, high quality, 
        building work, that seems to suit, even the most demanding of clients.
    </p>
    <p>
        In 2013 with the company on a strong footing Chris retired. Jon now shares his time between client meetings &amp; assisting where required with client decisions, 
        company administration work, personal site supervision &amp; when possible still enjoys working ‘on the tools’ with the team.
    </p>

    <p>
        Most of the craftsmen have worked together now for a long time (many for twenty plus years)
        so know each other very well &amp; always have an eye on how their particular trade will affect the next trade. 
        Meaning the job contracts generally run smoothly in an almost family like atmosphere.
    </p>
        
    <!--<img class="img-fluid center" alt="Jon Ray Building - high quality property renovation in Sussex and Kent" src="http://www.jonraybuilding.co.uk/images/house2.jpg" />-->

    <div class="card align-content-center text-center mx-auto d-block image">
        <img src="/assets/images/Portfolio/2_0.jpg" class="card-img-top img-fluid center" alt="Jon Ray Building - high quality property renovation in Sussex and Kent">
    </div>

    <p>
        Today the same conscientious &amp; methodical approach in carrying out the ‘right job’ that Denis Ray lived by, passed onto Chris &amp; subsequently onto Jon, 
        is expected from the whole team on every job no matter how big or small. 
        Everyone working on the company asks themselves the question "Would I be happy with that job on my own house?".  The answer must be yes, if not it must be done again.
    </p>
</div>